import { post } from '../../util'

export const GOOGLE_LOGIN_START = 'GOOGLE_LOGIN_START'
function loginStart() {
  return {
    type: GOOGLE_LOGIN_START,
  }
}

export const GOOGLE_LOGIN_ERROR = 'GOOGLE_LOGIN_ERROR'
function loginError(error) {
  return {
    type: GOOGLE_LOGIN_ERROR,
    error: error.toState(),
  }
}

export const GOOGLE_LOGIN_SUCCESS = 'GOOGLE_LOGIN_SUCCESS'
function loginSuccess(response) {
  return {
    type: GOOGLE_LOGIN_SUCCESS,
    response,
  }
}

export const doLogin = (user) => {
  return dispatch => {
    dispatch(loginStart())

    return post('/login_process.php', {
        source:      'google',
        source_page: document.location.pathname,
        feed_id:     user.username, // rename username to feedid for PHP
        ...user,
      })
      .then(r => dispatch(loginSuccess(r)))
      .catch(e => dispatch(loginError(e)))
  }
}



// WEBPACK FOOTER //
// ./client/Modules/AuthGoogle/actions.js